import React from 'react';

import DefaultCompanyLogo from '../../../public/static/images/default-company-logo.png';
import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { Image } from '../Image/Image';

export type CompanyLogoProps = {
  alt?: string | null;
  className?: string;
  /** The logo to show instead when there is none, or when the one given will not load. */
  fallback?: string | null;
  inverse?: boolean;
  monochromatic?: boolean;
  name?: string;
  src?: string | null;
  width?: string;
};

export const CompanyLogo = ({
  alt = 'Company Logo',
  className,
  fallback = DefaultCompanyLogo,
  inverse,
  monochromatic,
  name,
  src,
  width = '75px',
}: CompanyLogoProps) => {
  const logoClassName = AttrsHelper.formatClassname(
    'company-logo',
    monochromatic && 'image-monochromatic',
    inverse && 'image-inverse',
    className
  );

  return (
    <Image
      alt={alt || ''}
      className={logoClassName}
      /*
        The fallback is another logo, so it answers its own failure the same way: a default that
        will not load leaves the space empty rather than looping.
      */
      fallback={
        fallback ? (
          <Image
            alt={alt || ''}
            className={logoClassName}
            name={name}
            src={fallback}
            width={width}
          />
        ) : null
      }
      name={name}
      src={src}
      width={width}
    />
  );
};
